import { cn } from "@/lib/utils"

function Spinner({ className = "" }) {
    return (<>
        <div className={ cn([`w-1em aspect-square rounded-full animate-spin border-y-2 border-solid border-current
             border-t-transparent shadow-lg text-nfPurple-400`, className]) }>
        </div>
    </>

    )
}
export default Spinner